import { z } from 'zod';
export const uuidSchema = z.string().uuid();
/** Path-param schema for every `/<resource>/{id}` route. */
export const idParamSchema = z.object({
    id: uuidSchema,
});
//# sourceMappingURL=id.schemas.js.map